export default [
  {
    path: '/cuentas/por-cobrar',
    name: 'accountsReceivable',
    component: () => import('@/views/finance/Receivable.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    // Lo que el equipo ve como cuentas por pagar, el proveedor lo ve como sus cobros.
    path: '/proveedor/cuentas-por-cobrar',
    name: 'supplierReceivables',
    component: () => import('@/views/finance/SupplierReceivables.vue'),
    meta: {
      requiresAuth: true,
      requiresSupplierAdmin: true,
    },
  },
  {
    path: '/cuentas/por-pagar',
    name: 'accountsPayable',
    component: () => import('@/views/finance/Payables.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cuentas/balance',
    name: 'balance',
    component: () => import('@/views/finance/FinanceDashboard.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]
